import type { PublicApiKey } from '@/apilib';
import type { createPlatformApi } from './platformWrapper';

export const PlatformApiKey: PublicApiKey<typeof createPlatformApi> = {
  name: 'PlatformApi',
  public: true,
};
